// extracted by mini-css-extract-plugin
module.exports = {"parent-mobile-menu":"ParentNavItemListMobile_parent-mobile-menu__2sNAI","active":"ParentNavItemListMobile_active__2xEdA"};